import { Component, ElementRef, inject, signal } from '@angular/core';

import { Router } from '@angular/router';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatRipple } from '@angular/material/core';
import { AlertStore } from '../../../shared/state/alert.store';
import { Notificari } from '../../../shared/models/nav-notificari.model';

import { NavNotificariService } from './nav-notificari.service';
@Component({
    selector: 'app-nav-notificari',
    templateUrl: './nav-notificari.component.html',
    styleUrls: ['./nav-notificari.component.scss'],
    // meniul se inchide la click in afara lui
    host: {
        '(document:click)': 'onDocumentClick($event.target)',
        '(document:keydown.escape)': 'isOpen.set(false)',
    },
    imports: [MatIconButton, MatIcon, MatBadge, NgScrollbarModule, MatRipple]
})
export class NavNotificariComponent {
  private router = inject(Router);
  private _elementRef = inject(ElementRef);
  private service = inject(NavNotificariService);


  protected readonly notificariLista = inject(AlertStore).notificari;

  cssPrefix = 'toolbar-notification';
  protected readonly isOpen = signal(false);
  notifications = [];

  onDocumentClick(targetElement: EventTarget | null) {
    if (!targetElement) {
      return;
    }

    const clickedInside = this._elementRef.nativeElement.contains(
      targetElement as Node
    );
    if (!clickedInside) {
      this.isOpen.set(false);
    }
  }

  toggleDropdown() {
    this.isOpen.update(open => !open);
  }


  delete(event: Event, notification: Notificari) {
    event.stopPropagation();
    this.service.delNotificari(notification);
  }

  itemAction(event: Event, notification: Notificari) {
    event.stopPropagation();
    switch (notification.body.type) {
      case 'transfer':
        this.router.navigateByUrl('/cmj/cmj-transfer');
        break;

      case 'cpc':
        this.router.navigateByUrl('/cmj/cert-prof-curent');
        break;

      default:
        break;
    }
  }

  refresh() {
    this.service.getNotificari();
  }

}
